import { useSelector } from 'react-redux';
import config from 'config';

import { useEffect, useRef } from 'react';
import { useScalingRetryInterval } from './retry';
import { VideoCtvRedux } from '../store-types';

const initInterval = config.api.diffFetchInterval;

export const useDiffInterval = (): number => {
  const data = useSelector((state: VideoCtvRedux) => state.diff.data);
  const error = useSelector((state: VideoCtvRedux) => state.diff.error);

  const { interval, resetInterval, onErrorChange } = useScalingRetryInterval(
    initInterval,
  );

  const resetRef = useRef<(newBase?: number) => void>();
  const errorChangeRef = useRef<(error: unknown) => void>();
  useEffect(() => {
    resetRef.current = resetInterval;
    errorChangeRef.current = onErrorChange;
  });

  useEffect(() => {
    if (data) {
      // Business requirement for minimum time = default value
      resetRef.current?.(Math.max(data.maxAgeHeaderMs, initInterval));
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      errorChangeRef.current?.(error);
    }
  }, [error]);

  return interval;
};
